import { injectable } from "inversify"
import container from "../wires/Bootstrapper"
import SERVICE_IDENTIFIER from "../wires/Identifiers"
import { IApiService } from "./shared/ApiService"
import * as Api from "../constants/ApiUrlConstants"

import { ModelBase } from "../models/ModelBase"
import {
    ElencoPianiPrevisionaliModel,
    PianoPrevisionaleDetailsModel,
    PianoPrevisionaleIntestazione,
    PianoPrevisionaleOptions
} from "../models/PianoPrevisionaleModels"
import { IApiServiceExt } from "./shared/ApiServiceExt"
import {PianoPrevisionaleGetPianoPrevisonale} from "../constants/ApiUrlConstants";


export interface IPianoPrevisionaleService {
    GetPianiPrevisionaliList(clienteId: string): Promise<ElencoPianiPrevisionaliModel>
    // todo chiedere a Damiano
    CalcolaPianoProvvigionale(pianoId: string, model: PianoPrevisionaleIntestazione): Promise<ModelBase>

    GetPianoPrevisonaleDettagli(idpiano: string) : Promise<PianoPrevisionaleIntestazione>
    GetPianoPrevisonale(idpiano: string): Promise<PianoPrevisionaleDetailsModel>
}

@injectable()
export class PianoPrevisionaleService implements IPianoPrevisionaleService {
    apiService: IApiService
    apiServiceExt: IApiServiceExt

    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE);
        this.apiServiceExt = container.get(SERVICE_IDENTIFIER.API_SERVICE_EXT)
    }

    async CalcolaPianoProvvigionale(pianoId: string, model: PianoPrevisionaleIntestazione): Promise<ModelBase> {
        var url = Api.PianoPrevisionaleCalcolaPianoProvvigionale
        let options = new PianoPrevisionaleOptions()
        options.Anno = model.Anno
        options.Cliente = model.Cliente
        options.FatturoPrevisto = model.FatturoPrevisto
        options.IncassatoPrevisto = model.IncassatoPrevisto
        options.CostiFissiPercentuale = model.CostiFissiPercentuale
        options.CostiVariabiliPercentuale = model.CostiVariabiliPercentuale
        options.PianoId = pianoId
        return await this.apiServiceExt.postAsync<ModelBase>(url, options);
    }

    async GetPianiPrevisionaliList(clienteId: string): Promise<ElencoPianiPrevisionaliModel> {
        return await this.apiService.getAsync<ElencoPianiPrevisionaliModel>(Api.PianoPrevisionaleGetPianiPrevisionaliList, { ClienteId: clienteId });
    }

    async GetPianoPrevisonaleDettagli(idpiano: string): Promise<PianoPrevisionaleIntestazione> {
        return await this.apiService.getAsync<PianoPrevisionaleIntestazione>(Api.PianoPrevisionaleGetPianoPrevisonaleDettagli, { idpiano: idpiano });
    }

    async GetPianoPrevisonale(idpiano: string): Promise<PianoPrevisionaleDetailsModel> {
        return await this.apiService.getAsync<PianoPrevisionaleDetailsModel>(Api.PianoPrevisionaleGetPianoPrevisonale, { idpiano: idpiano });
    }


}